




































































import { defineComponent, ref } from '@vue/composition-api'
import KaiButton from './common/KaiButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faSearch,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { useTextSearch } from '../composables/useTextSearch'
import { useActions } from '../store/useActions'
import { useGetters } from '../store/useGetters'
import debounce from 'lodash/debounce'

export default defineComponent({
  name: 'TextSearch',
  components: { KaiButton, FontAwesomeIcon },
  setup(props, { root }) {
    const searchInput = ref<HTMLElement>()

    const actions = useActions({
      setSearchQuery: 'conversation/setSearchQuery',
      toggleSearch: 'conversation/toggleSearch',
      previousResult: 'conversation/previousSearchResult',
      nextResult: 'conversation/nextSearchResult'
    })

    const getters = useGetters({
      isSearchOpen: 'conversation/isSearchOpen',
      searchQuery: 'conversation/searchQuery',
      resultIndex: 'conversation/activeSearchResultIndex',
      searchResults: 'conversation/searchResults'
    })

    const setSearchQuery = debounce(actions.setSearchQuery, 500, {
      trailing: true
    })

    const handleSearch = (e: any) => {
      setSearchQuery(e.target.value || '')
    }

    const toggle = () => {
      actions.toggleSearch()

      if (getters.isSearchOpen && searchInput.value) {
        const input = searchInput.value as HTMLElement
        input.focus()
      }
    }

    function previousResult() {
      actions.previousResult()
      root.$nextTick(() => {
        useTextSearch(getters.resultIndex.value)
      })
    }

    const nextResult = () => {
      actions.nextResult()
      root.$nextTick(() => {
        useTextSearch(getters.resultIndex.value)
      })
    }

    return {
      searchInput,
      searchIcon: faSearch,
      closeIcon: faTimes,
      arrowUpIcon: faArrowUp,
      arrowDownIcon: faArrowDown,
      isSearchOpen: getters.isSearchOpen,
      searchQuery: getters.searchQuery,
      resultIndex: getters.resultIndex,
      searchResults: getters.searchResults,
      handleSearch,
      toggle,
      previousResult,
      nextResult
    }
  }
})
